<template>
  <div>
    <div class="ti d-flex">
      <div class="d-flex-left">
        <erp-tree @node-click="nodeClick"></erp-tree>
      </div>
      <div class="d-flex-right" style="margin-top: 10px;">
        <div style="width: 99%;">
          <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
            <el-descriptions-item label="房产信息">
              <el-input v-model="select.house_name" size="mini" placeholder="房产信息" disabled></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="支付时间">
              <el-date-picker v-model="select.pay_start" type="date" value-format="yyyy-MM-dd" size="mini"  style="width: 47%;" placeholder="开始日期"></el-date-picker>
              <span style="margin-left: 1px;margin-right: 1px;">至</span>
              <el-date-picker v-model="select.pay_end" type="date" value-format="yyyy-MM-dd" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item label="订单类型">
              <div>
                <el-select v-model="select.order_type_list" multiple filterable collapse-tags style="width: 70%" placeholder="订单类型">
                  <el-option size="mini" label="应收订单" value="order"></el-option>
                  <el-option size="mini" label="临时收费" value="temporary"></el-option>
                  <el-option size="mini" label="预收款" value="advance"></el-option>
                  <el-option size="mini" label="押金" value="deposit"></el-option>
                </el-select>
                <span style="cursor: pointer" @click="complete">全选</span>
                <span style="margin-left: 3px; cursor: pointer" @click="cancel">取消</span>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="状态">
              <el-select v-model="select.trade_status">
                <el-option size="mini" label="全部" value=""></el-option>
                <el-option size="mini" label="已支付" value="1"></el-option>
                <el-option size="mini" label="已退款" value="-1"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="绑定系统订单状态">
              <el-select v-model="select.bind_status">
                <el-option size="mini" label="全部" value=""></el-option>
                <el-option size="mini" label="已绑定" value="1"></el-option>
                <el-option size="mini" label="未绑定" value="0"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item>
              <el-button @click="change(1)">查询</el-button>
              <el-button @click="exportTable" >导出</el-button>
              <el-button @click="bankFlow">银行流水</el-button>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div style="margin-top: 10px;">

          <!-- 显示查询订单的总金额 -->
          <div class="total-amount" style="padding: 10px; background-color: #f5f5f5; border: 1px solid #ddd; margin-bottom: 10px;">
            <strong>查询结果总金额: ¥{{ trade_amount }}</strong>
          </div>

          <el-table ref="multipleTable" height="65vh" :data="tableData" border style="width: 99%" v-loading="table_loading"
                    @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" />
            <el-table-column prop="house_name" label="房产"></el-table-column>
            <el-table-column  label="状态" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.trade_status == 1">已支付</span>
                <span v-if="scope.row.trade_status == 0">支付中</span>
                <span v-if="scope.row.trade_status == -1">已退款</span>
              </template>
            </el-table-column>
            <el-table-column label="订单类型" width="150">
              <template slot-scope="scope">
                <span v-if="scope.row.order_type == 'order'">应收订单</span>
                <span v-if="scope.row.order_type == 'temporary'">临时收费</span>
                <span v-if="scope.row.order_type == 'advance'">预收款</span>
                <span v-if="scope.row.order_type == 'deposit'">押金</span>
              </template>
            </el-table-column>
            <el-table-column prop="pay_tool" label="支付工具" width="100"></el-table-column>
            <el-table-column prop="trade_channel" label="支付渠道" width="80"></el-table-column>
            <el-table-column prop="merchant_no" label="商户号"></el-table-column>
            <el-table-column prop="trade_no"  label="第三方交易号" width="180">
            </el-table-column>
            <el-table-column label="业主名称" prop="customer_name"></el-table-column>
            <el-table-column label="操作员" prop="operator_name"></el-table-column>
            <el-table-column label="POS编号" prop="pos_no"></el-table-column>
            <el-table-column label="终端号" prop="terminal_id"></el-table-column>
            <el-table-column label="发卡行" prop="bank"></el-table-column>
            <el-table-column label="卡号-序列号" prop="card_no"></el-table-column>
            <el-table-column prop="trade_time" label="交易时间" width="100"></el-table-column>
            <el-table-column label="交易类型" prop="trade_type"></el-table-column>
            <el-table-column prop="trade_amount" label="交易金额" width="80"></el-table-column>
            <el-table-column label="手续费" prop="service_charge"></el-table-column>
            <el-table-column label="凭证号" prop="bill_no"></el-table-column>
            <el-table-column prop="refund_time" label="退款时间" width="100"></el-table-column>
            <el-table-column prop="refund_no" label="退款单号" width="80"></el-table-column>
            <el-table-column prop="refund_remark" label="退款备注"></el-table-column>
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <el-button size="mini" v-if="!scope.row.house_id" @click="bindExistOrder(scope.row)" style="margin-right:8px;">
                  绑定订单
                </el-button>
<!--                <el-button size="mini" @click="handleShow(scope.row)">详情</el-button>-->
                <el-button size="mini" v-if="scope.row.trade_status == 1 && checkDelete(scope.row) && ERP.isPermission(40030170001)" type="danger"
                           @click="handleRefund(scope.row)">退款</el-button>
                <el-button size="mini" v-if="scope.row.trade_status == 1 && scope.row.house_id != 0 && ERP.isPermission(40030170001)" type="danger"
                           @click="handleRelease(scope.row)">解绑订单</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="float: right; margin-top: 10px; margin-right: 20px"
            background
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
            :page-sizes="[10,20,50,100,200,500]"
            :small="true"
            layout="sizes,prev, pager, next"
            :page-size="pageData.pageSize"
            :total="pageData.total"
            :current-page.sync="pageData.page"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="确认退款吗 ？" :visible="refund.visible" @close="refund.visible = false" v-loading="table_loading">
      <el-form>
        <el-form-item label="退款金额">
          <span >{{refund.money}}</span>
        </el-form-item>
        <el-form-item label="退款原因/备注">
          <el-input type="textarea" placeholder="请输入内容" v-model="refund.remark"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="sendRefund" type="primary">确定</el-button>
          <el-button @click="refund.visible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="银行流水" :visible="bank.visible" @close="bank.visible = false">
      <el-form :inline="true">
        <el-form-item label="POS设备号">
          <el-select v-model="bank.pos_no">
            <el-option label="全部" value="">
            </el-option>
            <el-option v-for="item in bank.pos_list" :key="item.id" :label="item.terminal_no" :value="item.terminal_no">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="查询时间">
          <el-date-picker
            v-model="bank.time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="searchBankFlow">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="bank.order_list" v-loading="bank.order_loading">
        <el-table-column label="交易时间" prop="trade_time"></el-table-column>
        <el-table-column label="参考号" prop="trade_no"></el-table-column>
        <el-table-column label="交易金额" prop="trade_amount"></el-table-column>
        <el-table-column label="POS设备号" prop="pos_no"></el-table-column>
        <el-table-column label="是否已绑定订单">
          <template slot-scope="scope">
            <span v-if="scope.row.is_bind_order">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button v-if="!scope.row.is_bind_order" size="mini" @click="bindOrder(scope.row)">补录ERP订单</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next"
                     @current-change="handleBankPageChange"
                     :current-page.sync="bank.page"
                     :page-count="bank.page_count"
                     :page-size="bank.page_size">
      </el-pagination>
    </el-dialog>

    <el-dialog title="补录订单" :visible="bind.visible" @close="bind.visible = false">
      <el-form>
        <el-form-item label="参考号">
          <el-input v-model="bind.trade_no" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="订单类型">
          <el-radio-group v-model="bind.order_type">
            <el-radio label="order">应收款</el-radio>
            <el-radio label="temporary">临时收费</el-radio>
            <el-radio label="advance">预收款</el-radio>
            <el-radio label="deposit">押金</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="收据号">
          <el-input v-model="bind.bill_no"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="sendBindOrder">确定</el-button>
          <el-button @click="bind.visible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'OnlineOrder',
  provide(){
    return{
      __ORDER__:null
    }
  },
  data () {
    return {
      pageData:{
        id:0,
        pid:0,
        list:[],
        total:0,
        page:1,
        pageSize:10,
      },
      selectList:[],
      select:{
        pay_start : '',
        pay_end : '',
        house_id : 0 ,
        order_type_list : [] ,
        house_name : '',
        pindex_id : 0,
        trade_status : '',
        bind_status : '',
      },
      pid:'',
      tableData: [],
      table_loading :false,
      // 订单总金额
      trade_amount : 0,

      refund:{
        visible : false,
        money : 0 ,
        remark : '' ,
        id : 0,
      },

      bank : {
        visible : false ,
        pos_no : '',
        pos_list : [],
        // 默认当天时间
        time: [],
        order_list : [],
        order_loading : false,
        page_count : 0,
        page : 1,
        page_size : 20,
      },

      bind : {
        visible : false,
        order_type : 1 ,
        bill_no : '',
        trade_no : '',
        merchant_no : '',
        trade_time : '',
        online_id : 0,
      }
    }
  },
  //界面没出来前加载
  created() {
    this.change();
  },
  // 加载数据
  mounted(){
    this.__ORDER__=this;
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    handleClose() {

    },
    //全选
    complete() {
      this.select.order_type_list = ['order' , 'temporary' , 'advance' , 'deposit'];
    },
    //取消
    cancel() {
      this.select.order_type_list = [];
    },
    //点击树
    nodeClick(data){
      if(data.tree.length > 0){
        // 最后一个元素
        let treeData = data.tree[data.tree.length - 1];
        if(treeData.type === 'project'){
          this.select.pindex_id = treeData.pindex_id;
          this.select.house_id = 0;
          this.select.house_name = treeData.name;
        }else{
          this.select.house_id = treeData.house_id ;
          this.select.house_name = treeData.ancestor_name;
        }
      }
    },
    //搜索账单
    change(e){
      this.table_loading = true;
      let params = Object.assign({} , this.select);
      params.page = this.pageData.page;
      params.limit = this.pageData.pageSize;
      this.$myhttp.post('admin/orderOnline',params,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{
        this.table_loading = false;
        console.log(backdata.data.data)
        if(backdata.data.code == 200){
          this.tableData = backdata.data.data.list;
          this.pageData.total = backdata.data.data.count;
          this.trade_amount = backdata.data.data.total;
        }else{
          this.$Message.error(backdata.data.msg);
        }
      } , err=>{
        this.table_loding = false;
        this.loading_dade = 1;
        //ERP.hideLoading()
        this.$Message.error('请求异常!');
      });
    },
    //查询该客户所有费项
    all(){
      this.select.all.type = 2;
      this.select.all.house = this.house.map(req=>{return req.id}).join(',');
      this.change(1);
    },

    //搜索框选中房产
    changes(e){
      this.select.name = '';
      this.user_type = 1;
      this.select.house = e;
      this.change(1);
    },
    //勾选账单
    handleSelectionChange(val) {
      this.order = val;
      let money = 0;
      this.order.map(req=>{
        money = Number(money) + Number(req.charge_money);
      })
      this.money_val = money.toFixed(2);
    },
    //搜索选中
    handleSelect(item) {

    },
    handlePageChange(e) {
      this.pageData.page = e;
      this.change();
    },
    handleSizeChange(val){
      this.pageData.pageSize = val;
      this.change();
    },
    // 检查是否可退款
    checkDelete(row){
      // 当月第一天时间戳
      let firstDay = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
      let tradeTime = new Date(row.trade_time);
      return tradeTime >= firstDay;
    },
    // 退款
    handleRefund(row){
      this.refund.id = row.id
      this.refund.money = row.trade_amount;
      this.refund.remark = '';
      this.refund.visible = true;
    },
    sendRefund(){
      if(this.refund.remark == ''){
        this.$Message.error('请填写退款原因');
      }else{
        let params = { id : this.refund.id , remark : this.refund.remark }
        this.table_loading = true;
        this.$myhttp.post('admin/OrderOnlineRefund',params,{
          'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{
          this.table_loading = false;
          if(backdata.data.code == 200){
            this.$Message.success('退款成功');
            this.refund.visible = false;
            this.change();
          }else{
            this.$Message.error(backdata.data.msg);
          }
        } , err=>{
          this.table_loading = false;
          this.loading_dade = 1;
          this.$Message.error('请求异常!');
        });
      }
    },
    // 导出报表
    exportTable(){
      let params = Object.assign({} , this.select);
      this.$myhttp.post('admin/OrderOnlineDownload',params,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{
        this.table_loading = false;
        if(backdata.data.code == 200){
          let url = backdata.data.data.url;
          window.open(this.$myhttp.defaults.baseURL +  url, "_blank");
        }else{
          this.$Message.error(backdata.data.msg);
        }
      } , err=>{
        this.table_loading = false;
        this.loading_dade = 1;
        this.$Message.error('请求异常!');
      });
    },
    // 银行流水
    bankFlow(){
      this.bank.visible = true;
      this.getPosList();
    },
    // 获取POS列表
    getPosList(){
      if(this.select.pindex_id == 0){
        this.$Message.error('请选择项目');
        return;
      }

      let url = 'admin/OrderOnline/getPosList?pid=' + this.select.pindex_id ;
      this.$myhttp.get(url ,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{
        if(backdata.data.code == 200){
          this.bank.pos_list = backdata.data.data;
          this.bank.order_list = [];
          this.bank.page = 1;
          this.bank.page_count = 0;
        }
      })
    },
    // 查询银行流水
    searchBankFlow(){
      if(this.select.pindex_id == 0){
        this.$Message.error('请选择项目');
        return;
      }
console.log(this.bank.time)
      this.bank.order_loading = true;
      let url = 'admin/OrderOnlineBankFlowList' ;
      let params = {
        pid : this.select.pindex_id,
        pos_no : this.bank.pos_no ,
        page : this.bank.page ,
        start_time : this.bank.time[0] ,
        end_time : this.bank.time[1],
      };
      this.$myhttp.post(url , params ,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{
        if(backdata.data.code == 200){
          this.bank.order_list = backdata.data.data.list;
          this.bank.page_count = backdata.data.data.page_count;
        }
        this.bank.order_loading = false;
      })
    },
    handleBankPageChange(val){
      this.bank.page = val;
      this.searchBankFlow();
    },
    // 补录订单
    bindOrder(row){
      this.bind.visible = true;
      this.bind.trade_no = row.trade_no;
      this.bind.merchant_no = row.merchant_no ;
      this.bind.trade_no = row.trade_no ;
      this.bind.trade_time  = row.trade_time;
      this.bind.order_type = '';
      this.bind.online_id = 0;
    },
    // 申请绑定订单
    sendBindOrder(){
      if(this.bind.trade_no == ''){
        this.$message.error('请选择银行订单');
        return;
      }
      if(this.bind.bill_no == ''){
        this.$message.error('请输入系统订单收据号');
        return;
      }
      if(this.bind.order_type == ''){
        this.$message.error('请选择订单类型');
        return ;
      }
      if(this.select.pindex_id == ''){
        this.$message.error('请选择项目');
        return ;
      }
      let params = {
        trade_no:this.bind.trade_no,
        bill_no:this.bind.bill_no,
        order_type:this.bind.order_type,
        trade_time : this.bind.trade_time,
        merchant_no : this.bind.merchant_no ,
        pindex_id : this.select.pindex_id,
        online_id : this.bind.online_id,
      }
      this.$myhttp.post('admin/orderOnlineBindOrder',params,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(res=>{
        if(res.data.code == 200){
          this.$message.success(res.data.msg);
          this.bind.trade_no = '';
          this.bind.bill_no = '';
          this.bind.order_type = '';
          this.bind.trade_time = '';
          this.bind.marchant_no = '';
          this.bind.visible = false;
          this.bank.visible = false;
          this.change();
        }else{
          this.$message.error(res.data.msg);
        }
      })

    },
    bindExistOrder(row){
      this.bind.trade_no = row.trade_no;
      this.bind.bill_no = '';
      this.bind.order_type = '';
      this.bind.trade_time = row.trade_time;
      this.bind.merchant_no = row.merchant_no;
      this.bind.online_id = row.id;
      this.bind.visible = true;
    },
    // 解绑订单
    handleRelease(row){
      this.$confirm('确认解绑缴费单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$myhttp.post('admin/orderOnlineRelease' , {id : row.id} , {
          'Content-Type': 'application/x-www-form-urlencoded'
        }).then(res => {
          if(res.data.code == 200) {
            this.$message.success(res.data.msg);
            this.change();
          }else{
            this.$message.error(res.data.msg);
          }
        });
      })
    },
  },
  watch:{

  },
  components: {
    "erp-tree": () => import('../Common/erp-tree.vue'),
  },

}
</script>

<style>
.d-flex {
  display: flex;
}
.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
  width: 250px;

}
.d-flex-right {
  flex: 1;
  overflow-x:hidden;
}
.text2{
  color: rgb(250, 248, 248);
}
</style>

<style lang="scss" scoped>
.right-main {
  display: flex;
  // overflow: auto;//体内容的滚动条
  flex: 1;
  background: #fff;
}
.content{
  .header{

  }
  .header-where{
    margin-top: 5px;
  }
  .body{
    margin-top: 10px;

    .pagination-wrap{
      display: table;
      /* text-align: center; */
      margin: 20px auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/OnlineOrder.vue